import { Component, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import * as DialogActions from 'app/dialog/features/dialog.actions';
import { Store } from '@ngrx/store';
import * as WebHookActions from '../../features/webhook-actions'
import { WebHookFormModalService } from '../../services/web-hook-form-modal/web-hook-form-modal.service';

@Component({
  selector: 'app-webhook-card',
  templateUrl: './webhook-card.component.html',
  styleUrl: './webhook-card.component.scss'
})
export class WebhookCardComponent implements OnInit,OnDestroy {
  
  @Input() webHook: any;
  public webHookStatusClass: string;
  public webHookStatusLabel: string;
  constructor(
    public router: Router,
    private store: Store,
    private webHookfFormModal: WebHookFormModalService,
  ){}
  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    this.webHookStatusClass = this.getStatusClass();
    this.webHookStatusLabel = this.getStatusLabel(this.webHook.status);
  }

  getStatusLabel(status: number){
    switch (status) {
      case 0:
        return 'Active';
      case 1:
        return 'Paused';
      case 2:
        return 'Deleted';
      case 3:
        return 'Failed';
      default:
        return 'Unknown';
    }
  }
  
  getStatusClass() {
    switch (this.webHook.status) {
      case 0:
        return 'badge shadow-none rounded-pill badge-success'; 
      case 1:
          return 'badge shadow-none rounded-pill badge-primary';
      case 2:
          return 'badge shadow-none rounded-pill badge-dark'; 
      case 3:
          return 'badge shadow-none rounded-pill badge-danger';
      default:
          return '';
    }
  }

  openWebHookDetails(event){
    this.router.navigateByUrl(`/integration/web-hook/${this.webHook.id}`)
  }

  onEdit(event){
    event.stopPropagation();
    this.webHookfFormModal.editOrAddWebHook(this.webHook);
  }

  onDelete(event) {
    event.stopPropagation();
    this.webHookfFormModal.onConfirmDelete(`Are you sure?`, `You want to delete this webhook.`, () => {
        this.store.dispatch(
          WebHookActions.deleteWebHook({ webHookId: this.webHook.id ,onDetailsPage: false})
        )
    });
  }

  onTestSend(event){
    event.stopPropagation();
    this.store.dispatch(
          WebHookActions.testSendWebHook({webHookId:this.webHook?.id})
    )
  }
}